<template>
  <div class="item" id="pg-start">
    <div class="left" data-toggle="collapse" data-target="#item-start" aria-expanded="true" aria-controls="item-start">
      <p class="text-add-course">Início</p>
    </div>
    <div id="item-start" class="text-center rigth show width"  aria-labelledby="pg-start" data-parent="#pg-add-course">
      <h3><b>Olá! Vamos lançar um curso novo?</b></h3>
      <h6>Este é o assistente Akdemica de criação de cursos</h6>
      <button
        class="btn btn-primary px-3"
        data-toggle="collapse"
        data-target="#item-info"
        aria-expanded="true"
        aria-controls="item-info"
      >Vamos lá!</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'add-course-start',
}
</script>
